// Mock data for Summit Life & Health Insurance

export const businessInfo = {
  name: "Summit Life & Health Insurance",
  agentName: "Mauriziu Antonelli",
  agentTitle: "Licensed Insurance Agent",
  npn: "21734978",
  location: "Miami, FL",
  phone: "(786) 601-6600",
  phoneTel: "+17866016600",
  email: "m.antonelli@summitlifehealth.com",
  hours: "8AM - 8PM EST",
  tagline: "Your Trusted Partner in Health Insurance",
  description: "Specializing in ACA marketplace plans and private off-market health insurance for individuals, families, self-employed professionals, and small businesses."
};

export const coveragePaths = [
  {
    id: "aca",
    label: "Path 1",
    title: "ACA Marketplace Plans",
    subtitle: "Affordable Care Act coverage through the federal marketplace — with every subsidy and tax credit you qualify for applied to lower your monthly premium.",
    audience: "Individuals, families, and self-employed professionals who qualify for income-based savings or need guaranteed coverage regardless of health history.",
    icon: "Landmark",
    benefits: [
      "Premium tax credits & cost-sharing reductions applied for you",
      "Guaranteed acceptance — no medical questions",
      "All 10 essential health benefits covered",
      "Open Enrollment and Special Enrollment Period guidance",
      "We handle Marketplace paperwork, payments, and renewals"
    ]
  },
  {
    id: "private",
    label: "Path 2",
    title: "Private Health Plans",
    subtitle: "Off-market coverage sold directly through private carriers — for people who don't qualify for subsidies or want more flexibility than the marketplace allows.",
    audience: "Individuals, families, and small businesses who want year-round enrollment, broader networks, or a lower price than unsubsidized marketplace plans.",
    icon: "Building2",
    benefits: [
      "Enroll any time of the year — no Open Enrollment deadline",
      "Not based on income or subsidy eligibility",
      "Access to PPO and nationwide networks",
      "Often more affordable than unsubsidized marketplace plans",
      "Small business and group solutions available"
    ]
  }
];

export const services = [
  {
    id: 1,
    title: "ACA & Private Plans",
    description: "Expert guidance across both ACA marketplace plans and private off-market options — tailored to individuals, families, and the self-employed.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Plan Selection Guidance",
    description: "Fully transparent guidance in selecting the right plan adapted to your specific healthcare needs and budget.",
    icon: "FileCheck"
  },
  {
    id: 3,
    title: "White Glove Service",
    description: "Comprehensive support including payment processing, ID card orders, PCP selection, and direct carrier communication.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Small Business Solutions",
    description: "Coverage strategies built for small businesses and self-employed professionals — without the hassle of dealing with carriers directly.",
    icon: "Sparkles"
  }
];

export const carriers = [
  { 
    name: "Ambetter", 
    id: 1,
    logo: "/logos/ambetter.png",
    size: "medium"
  },
  { 
    name: "UnitedHealthcare", 
    id: 2,
    logo: "/logos/unitedhealthcare.png",
    size: "xlarge"
  },
  { 
    name: "Oscar Health", 
    id: 3,
    logo: "/logos/oscar.png",
    size: "xsmall"
  },
  { 
    name: "BlueCross BlueShield", 
    id: 4,
    logo: "/logos/bluecross.png",
    size: "medium"
  },
  { 
    name: "Cigna", 
    id: 5,
    logo: "/logos/cigna.png",
    size: "xlarge"
  },
  { 
    name: "Wellpoint", 
    id: 6,
    logo: "/logos/wellpoint.png",
    size: "xlarge"
  },
  { 
    name: "Imperial", 
    id: 7,
    logo: "/logos/imperial.png?v=2",
    size: "medium"
  },
  { 
    name: "AmeriHealth", 
    id: 8,
    logo: "/logos/amerihealth.png",
    size: "medium"
  },
  { 
    name: "Antidote Health", 
    id: 9,
    logo: "/logos/antidote.png",
    size: "medium"
  }
];

export const serviceStates = [
  { code: "FL", name: "Florida", primary: true },
  { code: "NC", name: "North Carolina", primary: false },
  { code: "SC", name: "South Carolina", primary: false },
  { code: "TX", name: "Texas", primary: false },
  { code: "TN", name: "Tennessee", primary: false },
  { code: "AZ", name: "Arizona", primary: false },
  { code: "GA", name: "Georgia", primary: false },
  { code: "KY", name: "Kentucky", primary: false },
  { code: "IL", name: "Illinois", primary: false },
  { code: "ME", name: "Maine", primary: false },
  { code: "MD", name: "Maryland", primary: false },
  { code: "NJ", name: "New Jersey", primary: false },
  { code: "PA", name: "Pennsylvania", primary: false },
  { code: "WA", name: "Washington", primary: false },
  { code: "NV", name: "Nevada", primary: false },
  { code: "VA", name: "Virginia", primary: false }
];

export const licenses = [
  { state: "Florida", number: "FL-123456" },
  { state: "North Carolina", number: "NC-789012" },
  { state: "South Carolina", number: "SC-345678" },
  { state: "Texas", number: "TX-901234" },
  { state: "Tennessee", number: "TN-567890" },
  { state: "Arizona", number: "AZ-234567" }
];
